export interface FormatStringResult {
  result: string
  caretPosition: number
}

export const formatString = (input: string, formatter: string, caretPosition?: number): FormatStringResult => {
  if (!formatter || !input) {
    return {
      caretPosition: caretPosition || 0,
      result: input
    }
  }
  caretPosition = caretPosition || 0

  const formatted = input.split('')

  for (let i = 0; i < formatted.length; i++) {
    const format = formatter[i]
    const char = formatted[i]
    switch (format) {
      case '9':
      case '#':
        if (/[^0-9]/g.test(char)) {
          formatted.splice(i, 1)
          if (i < caretPosition) {
            caretPosition--
          }
          i--
        }
        break

      case 'A':
        if (/[^A-Za-z]/g.test(char)) {
          formatted.splice(i, 1)
          if (i < caretPosition) {
            caretPosition--
          }
          i--
        }
        break

      case '*':
        if (/[^A-Za-z0-9]/g.test(char)) {
          formatted.splice(i, 1)
          if (i < caretPosition) {
            caretPosition--
          }
          i--
        }
        break

      case undefined:
      case null:
      case '':
        formatted.splice(i, 1)
        break

      default:
        if (char !== format) {
          formatted.splice(i, 0, format)
          if (i <= caretPosition) {
            caretPosition++
          }
        }
    }
  }

  return {
    caretPosition,
    result: formatted.join('')
  }
}

export const stripFormatting = (input: string, formatter: string): string => {
  if (!formatter || !input) {
    return input
  }

  const formatted = input.split('')
  const formatterArr = formatter.split('')

  for (let i = 0; i < formatted.length; i++) {
    const format = formatterArr[i]
    const char = formatted[i]
    switch (format) {
      case '9':
      case '#':
      case 'A':
      case '*':
        break
      case undefined:
      case null:
      case '':
        formatted.splice(i, 1)
        break

      default:
        if (char === format) {
          formatted.splice(i, 1)
          formatterArr.splice(i, 1)
          i--
        }
    }
  }

  return formatted.join('')
}

export const formatAsDate = (d: Date | null | undefined): string => {
  if (d) {
    const date = new Date(d)
    return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/services/string-formatter.ts